import api from '@/utils/api';

const { baseApi } = window.GlobalConfig;

// 客户总览分页
export const QueryCustPage = data => {
    return api.post(`/customer/getCustomerListPage`, data);
};
